import React, { useEffect } from 'react';
import 'styles/pages/ContactPage.scss';
import Location from 'components/common/Location';
import { useSelector } from 'react-redux';

const ContactPage = () => {
    const moreThan768 = useSelector((state) => state.moreThan768.value);

    // 스크롤 방향 감지
    useEffect(() => {
        let lastScrollY = 0;

        if (moreThan768) {
            const handleScroll = e => {
                const navbarEl = document.querySelector('.Navbar');
                const scrollY = window.scrollY;
                const direction = scrollY > lastScrollY ? 'scroll Down' : 'scroll Up';
                lastScrollY = scrollY;
                if (direction === 'scroll Down') {
                    navbarEl.classList.add('scrolled');
                } else if (direction === 'scroll Up') {
                    navbarEl.classList.remove('scrolled');
                }
            };

            handleScroll();
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            }
        } else {
            const navbarEl = document.querySelector('.Navbar');
            navbarEl.classList.remove('scrolled');
        }

    }, [moreThan768]);


    return (
        <section className='ContactPage'>
            <div className='Contact-wrapper'>
                <div className='top'>
                    <div className='top-title'>CONTACT</div>
                    <div className='top-text'>
                        국방/공공 분야 소프트웨어 및 제품 개발에 <br className="lineBreak" /> 어질인소프트의 최고 전문가들이 함께하겠습니다
                    </div>
                </div>
                <div className='bottom'>
                    <div className='bottom-map'>
                        <Location />
                    </div>
                    <div className='bottom-box'>
                        <div className='box-title'>본사 <span className='fc_blue'>(대전 대화동)</span></div>
                        <div className='box-items'>
                            <div className='box-item item-address'>
                                <div className='fc_grey'>주소 </div>
                                <div>
                                    <p>대전 대덕구 대화로 106번길 66, 1002호</p>
                                    <p>(대화동, 펜타플렉스)</p>
                                </div>
                            </div>
                            <div className='box-item'>
                                <span className='fc_grey'>교통 </span><br className='lineBreak' />버스 제일사료 정류장 하차<span className='fc_grey'> : 316번, 616번</span>
                            </div>
                            <div className='box-item'>
                                <span className='fc_grey'>연락처 </span><br className='lineBreak' />042-472-2094
                            </div>
                            <div className='box-item'>
                                <span className='fc_grey'>이메일 </span><br className='lineBreak' />master@agilinsoft.com
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.memo(ContactPage);